import {
  DataListExtraColumn,
  DataListHeader,
  DataListRow,
  Grid,
  GridCell,
  Panel,
  SKELETON_LOADER_VARIANT_ONWHITE,
  SkeletonLoader,
  TOAST_VARIANT_ERROR,
  toastShow
} from 'mailup-web-components'
import DeleteWarningMessage from 'Pages/SourcesList/components/DeleteWarningMessage'
import ModalDelete from 'Pages/SourcesList/components/ModalDelete'
import ModalSharedLists from 'Pages/SourcesList/components/ModalSharedLists'
import {
  changeColumnsOrderCallback,
  deleteSourceCallback,
  initPageCallback,
  pageChangeCallback
} from 'Pages/SourcesList/recoil/callbacks/callbacks'
import { modalDeleteState } from 'Pages/SourcesList/recoil/state/modals'
import { pageState } from 'Pages/SourcesList/recoil/state/page'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue, useResetRecoilState } from 'recoil'
import ItemTable from './ItemTable'

import Pagination from './Pagination'

const Results = ({ datas }) => {
  const intl = useIntl()

  const { loaded, pageSize, pageNumber, totalItems, orderBy, orderDescending } =
    useRecoilValue(pageState)

  const { show, idRow } = useRecoilValue(modalDeleteState)

  const handleChangeColumnsOrder = useRecoilCallback(changeColumnsOrderCallback)
  const handleChangePage = useRecoilCallback(pageChangeCallback)
  const initPage = useRecoilCallback(initPageCallback, [])
  const deleteSource = useRecoilCallback(deleteSourceCallback, [])
  const EXTRA_COLUMN_AFTER_WIDTH = '30px'

  const heads = [
    {
      field: 'SourceName',
      label: intl.formatMessage({
        id: 'Load.ContentsSouces.SourceName'
      }),
      span: 4,
      sortable: true
    },
    {
      field: 'UpdateDate',
      label: intl.formatMessage({
        id: 'Load.MailupCommon.LastUpdate'
      }),
      span: 3,
      sortable: true
    },
    {
      label: intl.formatMessage({
        id: 'Load.ContentsSouces.LastUpdateContents'
      }),
      span: 3
    },
    {
      label: intl.formatMessage({
        id: 'Load.Common.Contents'
      }),
      span: 2
    }
  ]

  const onDeleteWarning = (
    relatedCampaigns,
    userLists,
    currentList,
    sourceName
  ) => {
    toastShow(
      <DeleteWarningMessage
        relatedCampaigns={relatedCampaigns}
        userLists={userLists}
        currentList={currentList}
        sourceName={sourceName}
      />,
      TOAST_VARIANT_ERROR
    )
  }

  const handelDeleteCancel = useResetRecoilState(modalDeleteState)
  const handelDeleteConfirm = () => {
    deleteSource(idRow, onDeleteWarning).then((e) => {
      if (e) {
        if (pageNumber > 1) {
          const r = totalItems % pageSize
          if (r === 1) {
            handleChangePage(pageNumber - 1)
          }
        } else {
          initPage()
        }
      }
    })
  }

  return (
    <>
      <ModalDelete
        show={show}
        handleCancel={handelDeleteCancel}
        handleConfirm={handelDeleteConfirm}
      />
      <ModalSharedLists />

      <Panel>
        <DataListHeader
          heads={heads}
          afterWidth={EXTRA_COLUMN_AFTER_WIDTH}
          orderByStatus={orderBy}
          orderDescendingStatus={orderDescending}
          handleChangeColumnsOrderCallback={handleChangeColumnsOrder}
        />
        <div>
          {loaded && (
            <>
              {datas.map((item, i) => {
                return <ItemTable key={i} dataRow={item} heads={heads} />
              })}
            </>
          )}
          {!loaded && (
            <>
              {[...Array(pageSize)].map((item, key) => (
                <DataListRow key={key}>
                  <Grid cols={12}>
                    <GridCell span={heads[0].span}>
                      <SkeletonLoader
                        variant={SKELETON_LOADER_VARIANT_ONWHITE}
                      />
                    </GridCell>
                    <GridCell span={heads[1].span}>
                      <SkeletonLoader
                        variant={SKELETON_LOADER_VARIANT_ONWHITE}
                      />
                    </GridCell>
                    <GridCell span={heads[2].span}>
                      <SkeletonLoader
                        variant={SKELETON_LOADER_VARIANT_ONWHITE}
                      />
                    </GridCell>
                    <GridCell span={heads[3].span}>
                      <SkeletonLoader
                        variant={SKELETON_LOADER_VARIANT_ONWHITE}
                      />
                    </GridCell>
                  </Grid>
                  <DataListExtraColumn after width={EXTRA_COLUMN_AFTER_WIDTH} />
                </DataListRow>
              ))}
            </>
          )}
        </div>
        <Pagination />
      </Panel>
    </>
  )
}

export default Results

Results.propTypes = {
  datas: PropTypes.array
}
